"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlContentClassName = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var htmlUtils_1 = require("../htmlUtils");
var utils_1 = require("../types/utils");
exports.htmlContentClassName = 'htmlcontent';
var HtmlContent = function (_a) {
    var html = _a.html, className = _a.className, addNoContextForImages = _a.addNoContextForImages, style = _a.style;
    var appId = (0, utils_1.useYouwellCommonSelector)(function (state) { return state.pageSettings.appConfig.appId; });
    if ((0, htmlUtils_1.isEmptyHtml)(html)) {
        return null;
    }
    return (
    /* eslint-disable react/no-danger */
    React.createElement("div", { dangerouslySetInnerHTML: { __html: (0, htmlUtils_1.replaceEmbedContent)(html, addNoContextForImages, appId) }, className: (0, classnames_1.default)(exports.htmlContentClassName, className), style: style })
    /* eslint-enable react/no-danger */
    );
};
HtmlContent.defaultProps = {
    html: null,
    className: null,
    addNoContextForImages: false,
    style: null,
};
exports.default = HtmlContent;
